import { Box, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'


const AppOrderItem = ({value, title, currency, inputSx, valueFull}) => {
	const { theme, t } = useDefaultComponentTools()
	return (
		<Grid item sx={{ padding: '8px 0', ...inputSx }} xs={6}>
			<Typography variant='px14' sx={{color: theme.palette.text.primary}} className='title'>
				{t(title)}
			</Typography>
			<Box sx={{alignItems: 'baseline', display:'flex'}}>
				<Typography
					title={valueFull ? valueFull : null}
					variant='px16' component={'span'}
					className='value'> {value}</Typography>
				{!currency ? null :<Typography className='currency' sx={{ml: '4px'}}> {currency}</Typography>}
			</Box>
		</Grid>
	)
}

AppOrderItem.propTypes = {
	currency: PropTypes.string,
	inputSx: PropTypes.object,
	title: PropTypes.string,
	value: PropTypes.any,
	valueFull: PropTypes.any

}

export { AppOrderItem }
